import { render, staticRenderFns } from "./AffiliateInfo.vue?vue&type=template&id=77fea793&"
import script from "./AffiliateInfo.vue?vue&type=script&lang=js&"
export * from "./AffiliateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports